<p-dialog
  [visible]="open()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [styleClass]="'ui-dialog ui-dialog--' + tone()"
  [maskStyleClass]="'ui-dialog-backdrop'"
  [contentStyle]="{ padding: '0' }"
  [breakpoints]="{ '640px': '95vw' }"
  [style]="{ width: 'min(32rem, 100%)' }"
  (visibleChange)="onVisibleChange($event)"
>
  <div class="ui-dialog__content" [attr.data-tone]="tone()" role="dialog" aria-modal="true" aria-labelledby="ui-dialog-title">
    <section class="ui-dialog__shell">
      <header class="ui-dialog__header">
        <span class="ui-dialog__icon material-symbols-rounded" aria-hidden="true">
          {{ tone() === 'danger' ? 'warning' : 'info' }}
        </span>
        <h3 id="ui-dialog-title">{{ title() | uiLabelTranslate }}</h3>
      </header>

      @if (description()) {
        <p class="ui-dialog__description">{{ description() | uiLabelTranslate }}</p>
      }

      <footer class="ui-dialog__actions">
        <ui-button variant="secondary" (click)="cancelAction.emit()">{{ cancelLabel() | uiLabelTranslate }}</ui-button>
        <ui-button [variant]="tone() === 'danger' ? 'danger' : 'primary'" (click)="confirmAction.emit()">{{ confirmLabel() | uiLabelTranslate }}</ui-button>
      </footer>
    </section>
  </div>
</p-dialog>
